<template>
    <div class="cliente-select-wrapper">
    <Multiselect
        :model-value="modelValue"
        :options="buscarClientes"
        value-prop="idc"
        label="nombreFiscal"
        :object="true"
        :searchable="true"
        :min-chars="1"
        :delay="300"
        :resolve-on-load="false"
        :filter-results="false"
        :placeholder="placeholder"
        :disabled="disabled"
        no-options-text="Escribe para buscar..."
        no-results-text="Sin resultados"
        @update:model-value="emit('update:modelValue', $event)"
    />
    </div>
</template>

<script setup lang="ts">
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import { clientesApi } from '@/api/clientesApi'
import type { Cliente } from '@/types/cliente'

withDefaults(defineProps<{
    modelValue: Cliente | null
    placeholder?: string
    disabled?: boolean
}>(), {
    placeholder: 'Buscar cliente...',
    disabled: false,
})

const emit = defineEmits<{
    'update:modelValue': [value: Cliente | null]
}>()

async function buscarClientes(query: string): Promise<Cliente[]> {
    const result = await clientesApi.getAll({ search: query, activo: 1, pageSize: 20 })
    return result.items
}
</script>

<style>
.cliente-select-wrapper .multiselect {
    --ms-font-size: 0.875rem;
    --ms-line-height: 1.5;
    --ms-py: 0.25rem;
    --ms-px: 0.5rem;
    --ms-min-height: 31px;
    --ms-ring-width: 0;
    --ms-ring-color: transparent;
    --ms-border-color-active: #86b7fe;
    --ms-option-font-size: 0.875rem;
    --ms-option-py: 0.25rem;
    --ms-option-px: 0.5rem;
}
</style>
